
  
  
  <template>
    <div class="Details">
        <div class="container is-fluid">
      <div class="">
        
      </div>
      <br>
      
      
      
      <div class="container is-max-desktop">
        <div class="hero-body">
    <p class="title is-1">
      {{  project.name }}
    </p>
    <p class="subtitle" v-if="project.description">
        {{  project.description }}
    </p>
    <!-- <b-tabs type="is-boxed">
            <b-tab-item label="Make Predictions" ></b-tab-item>
            <b-tab-item label="Model card" ></b-tab-item>
            <b-tab-item label="History"></b-tab-item>
        </b-tabs> -->
    
        <form v-on:submit.prevent="invoke()">
            <b-field  message="">
                    <b-input maxlength="500"  expanded
                        rows="4"
                        size="is-medium"
                        required
                        type="textarea" v-model="text" 
                        placeholder="Text">
                    </b-input>
        </b-field>
        <b-field>
        <b-button
            expanded
            size="is-medium"
            tag="button"
            type="is-info"
            native-type="submit"
            value="Compute"
            ><i class="fa fa-play" aria-hidden="true"></i> Inference</b-button>
        </b-field>
        <b-button class="has-text-centered" size="is-medium" type="is-ghost">Upload CSV or JSON</b-button>

            <br>
            
            <b-notification :closable="false" v-if="isLoading">
                Invoking model...
                <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false">
                </b-loading>
                </b-notification>
                <div class="boxx" v-if="result && !isLoading">
                    <b-field message="This is the model result">
                        <b-notification style="overflow-wrap: break-word; color: #f1f1f1; background: #222;" :closable="false">
                        &nbsp;{{ "prediction" in result ? result["prediction"] : result | pretty }}
                        </b-notification>
                        <pre v-if="project.type == 'answering'" style="overflow-wrap: break-word; color: #f1f1f1; background: #222;">{{  result | pretty }}</pre>
                    </b-field>
                </div>
            

        </form>

            

        <!-- batch inference -->

        <div class="" >
            <!-- <b-field grouped message="What do you want to search?">
                <b-input placeholder="Search..."></b-input>
                <p class="control">
                    <b-button label="Search" type="is-primary" />
                </p>
            </b-field> -->

                

                
                <div class="columns is-desktop">
                <div class="column">
                    <div class="columns">
                    <div class="column is-12">
                        <div class="buttons is-pulled-right">
                            <b-button v-if="inputFile"  type="" size="" @click="cancelUpload()">
                            Cancel
                            </b-button>
                            <!-- <b-button :disabled="!ready_to_import || block" class="fixed-button  is-info" @click="uploadFile()"  size="is-mediumx">
                                Run
                            </b-button> -->
                            <b-button :disabled="!set_predictions" class="is-info" @click="downloadCsv">
                                <i class="fa fa-download" aria-hidden="true"></i>

                                &nbsp;Export data
                            </b-button>
                        </div>
                    
                    <span v-if="currentUser.plan && !inputFile">
                        <h4 class="title is-5">
                            Run bulk inference and export to csv
                        </h4>
                        <h4 class="subtitle is-5">
                            Upload your data from csv file, map the text column and get predictions
                        </h4>
                    </span>
                    <span v-else-if="set_text_column">
                    <h4 class="title is-5">Map the text column</h4>
                        <h4 class="subtitle is-5">
                            Select the column containing the text data to be predicted
                        </h4>
                        <!-- <b-field label="Options">
                            <b-switch v-model="header" @input="parseFile">
                                {{ (header?'First row is header':'No header') }}
                            </b-switch>
                        </b-field> -->
                    </span>
                    <span v-else-if="set_predictions">
                        <span v-if="predictions < 1">
                            <h4 class="title is-5" v-if="file_rows < 1500">
                                <b-button label="A" style="margin-right:1em;border: 0;" size="is-small" :loading="true"></b-button>&nbsp;
                                Inferring {{ file_rows }} texts...
                            </h4>
                            <h4 class="title is-5" v-else>
                                <b-button label="A" style="margin-right:1em;border: 0;" size="is-small" :loading="true"></b-button>&nbsp;
                                Inferring {{ file_rows }} texts...
                                <br>
                                <small class="subtitle is-6">
                                    It can take several minutes due to the CSV size. We recommend to use the API on this cases.
                                </small>
                            </h4>
                        </span>
                        <span v-else>
                            <h4 class="title is-5">
                                Done! Total of {{  predictions }} predictions
                            </h4>
                            <h4 class="subtitle is-5">
                                Now you can export your data to CSV
                            </h4>
                        </span>
                    </span>
                    
                </div>
                </div>
                </div>
            </div>
            <div class="columns is-desktop" v-if="currentUser.plan && !inputFile">
                <div class="column">
                    <div class="columns">
                    <div class="column is-12">
                    
                    <b-notification type="is-warning" v-if="(currentUser.creditsLimit - currentUser.predictionsTotal) < 1">
                            <p><b>You reached the limit of predictions (Total used is {{ currentUser.predictionsTotal }})</b></p>
                            <p>Upgrade to a paid plan to be able to upload more data</p>
                            <p>Contact us to increase resources on demand</p>
                        </b-notification><br>
                        
                    <b-field>
                        <b-upload 
                        v-model="inputFile"
                        @input="changeInput"
                        drag-drop 
                        accept=".csv"
                        expanded
                        required
                        :disabled="(project.userId != currentUser.id) || (currentUser.creditsLimit - (currentUser.creditsTotal)) < 1">
                            <section class="section">
                            <div class="content has-text-centered" v-if="!inputFile">
                                <p>
                                    <b-icon icon="upload" size="is-large"></b-icon>
                                </p>
                                <p>Accept .CSV file type</p>
                                <p><b>This feature is addressed to CSV files with up to ~2000 rows</b></p>
                                <p>For larger files, we recommend the use of the API</p>
                                <p>Contact us if you need help</p>
                                
                                <p>{{  (currentUser.creditsLimit - (currentUser.creditsTotal)) }} predictions remaining</p>
                            </div>
                            <div class="content has-text-centered" v-else>
                                <div class="subtitle is-4">
                                    {{ inputFile.name }} 
                                </div>
                                <span v-if="(inputFile.size/1024/1024) < 1000.00">
                                    Size: {{ (inputFile.size/1024/1024).toFixed(2) }} MB
                                </span>
                                <span v-else>
                                    Size: {{ (inputFile.size/1024/1024/1024).toFixed(2) }} GB
                                </span>
                            </div>
                            </section>
                        </b-upload>
                    </b-field>
                </div>
                </div>
                </div>
                </div><!-- columns-->

                <section class="" v-if="set_text_column">
                    
                    <div class="container">
                        <div class="table-container is-scrollable">
                        <table class="table is-fullwidth is-striped" v-if="parsed" style="width: 100%;">
                            <thead>
                                <tr>
                                    <th v-for="(headerCol, key) in fields"
                                        v-bind:key="'header-'+key">
                                        <b-button @click="setTextColumn(headerCol, key)" class="is-info" size="is-x" outlined>
                                            {{ (!header?`Column ${headerCol}`:String(headerCol).substring(0, 10)) }}
                                        </b-button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, rowKey) in content.data"
                                    v-bind:key="'row-'+rowKey">
                                        <td v-for="(column, columnKey) in fields"
                                            v-bind:key="'row-'+rowKey+'-column-'+columnKey">
                                                <span v-if="content.data[rowKey][column].length > 50">
                                                    {{ content.data[rowKey][column].substring(0, 50) }}...
                                                </span>
                                                <span v-else>
                                                    {{ content.data[rowKey][column] }}
                                                </span>
                                                
                                        </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </section>

                <section class="" v-else-if="set_predictions">
                    
                    <!-- <table class="table is-fullwidth is-striped is-hoverable">
                        <thead>
                            <tr>
                                <th>Label</th>
                                <th># Predictions</th>
                                <th>Avg Confidence</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :key="idx" v-for="(i, idx) in project.labels">
                                <td>{{  i.label }}</td>
                                <td>{{ predictions_results.filter(doc => doc[fields.indexOf('prediction')] == i.label).length }}</td>
                                <td>{{ calcAvgConfidence(predictions_results, i.label) }}</td>
                            </tr>
                        </tbody>
                    </table> -->
                    <hr>

                    <div class="container">
                        
                        <div class="table-container is-scrollable">
                        <table class="table is-fullwidth is-striped" v-if="parsed" style="width: 100%;">
                            
                            <thead>
                                <tr>
                                    <th v-for="(headerCol, key) in fields"
                                        v-bind:key="'header-'+key">
                                        <b-button v-if="text_column_key == key" class="is-info" size="is-mediumx" disabled>
                                            Text
                                        </b-button>
                                        <b-button v-else-if="['Prediction', 'Confidence'].includes(headerCol)" class="is-info" size="is-mediumx" disabled>
                                            {{ headerCol }}
                                        </b-button>
                                        <b-button v-else class="is-ghost" size="is-mediumx" disabled>
                                            {{ (!header?`Column ${headerCol}`:headerCol.substring(0, 10)) }}
                                        </b-button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, rowKey) in predictions_results.slice(0,10)"
                                    v-bind:key="'row-'+rowKey">
                                        <td v-for="(rowColumn, rowColumnKey) in row"
                                            v-bind:key="'row-'+rowKey+'-column-'+rowColumnKey">
                                                <span v-if="rowColumn.length > 50">
                                                    {{ rowColumn.substring(0, 50) }}...
                                                </span>
                                                <span v-else>
                                                    {{ rowColumn }}
                                                </span>
                                        </td>
                                </tr>
                            </tbody>
                        </table>

                        
                        </div>
                    </div>
                    
                </section>
                
                
            </div>

            <br>
        <b>PREDICTIONS</b>
        {{ prediction_results }}
        <div v-for="row in prediction_results">
            <Records :train="false" :row="row" :project="project" :currentOrg="currentUser" :currentUser="currentUser"></Records>
            <br>
        </div>

        </div>
</div>
  
      <footer class="block">
        <br><br>
        <div class="has-text-centered">
            <span style="padding-left: 0.5em; color: #3482F6;font-size: 1.6em; font-weight: bolder;">
                      <svg style="padding-top: 0.1em; padding-bottom: -10px;" xmlns="http://www.w3.org/2000/svg" 
                      class="iconx icon-tabler icon-tabler-cube-unfolded" 
                      width="29" height="29" 
                      viewBox="0 0 24 24" 
                      stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
     <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
     <path d="M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5z"></path>
     <path d="M7 15v-5h5v5h5v-5"></path>
  </svg>
  
  
                      Metatext
                    </span>
        </div>
        <br><br>
      </footer>
  
      
    </div>
    <section>
        <div>
        </div>
    </section>

    </div>
    
</template>
<script>
import Papa from 'papaparse';
import { mapState } from 'vuex';
import Records from "@/dashboard/Project/Records.vue";
export default {
     props: ["projectId"],
     name: "Uploads",
     data: function() {
    return {
        inferenceUrl: 'https://api.metatext.ai/v1/inference/',
        model_url: 'https://api.metatext.ai/inference/' + this.project.id,
        model_url_batch: 'https://api.metatext.ai/inference-batch/' + this.project.id,
        api_key: 'YOUR_API_KEY',
        all_users_api_key: 'Z0CDIgI42M5hggX0bpBB61UZswN4NiHNaqqsFIWd',
        
        result: null,
        text: '',
        uploads: [],
        inputFile: null,
        data: null,
        content: null,
        parsed: false,
        header: true,
        set_text_column: false,
        set_label_column: false,
        set_extra_fileformat: false,
        ready_to_import: false,
        text_column_name: null,
        text_column_key: null,
        label_column_name: null,
        label_column_key: null,
        datasetIds: [],
        isLoading: false,
        isLoadingBatch: false,
        isComplete: false,
        isModalLabelsOpen: false,
        block: false,
        ready_to_import_text: "Great! Ready to upload",
        unique_labels: [],
        labels: [],
        projectId: null,
        datasetId: null,
        uploadId: null,
        delimiter: null,
        set_predictions: false,
        predictions: 0,
        predictions_results: [],
        fields_keys: [],
        file_rows: 0,
        row: {
            text: null,
            label: null
        }
      }
    },
    computed: {
        prediction_results(){
            return this.$store.getters.getPredictionsResult
        },
        currentUser() {
            return this.$store.state.currentUser;
        },
        project() {
            return this.$store.state.project;
        },
    },
    components: {
        Records
      
    },
    filters: {
        pretty: function(value) {
            console.log(value)
            return JSON.stringify(value, null, 2);
        }
    },
     methods: {
        
        downloadCsv(){
            let pred_to_export = [this.fields].concat(this.predictions_results)

            let data = Papa.unparse(
                pred_to_export, {
                    header: this.header,
                });
            

            const url = window.URL.createObjectURL(new Blob([data]))
            const link = document.createElement('a')
            link.href = url
            // name to lowercase
            let name = this.project.name.toLowerCase()
            let filename = `metatext_${name}_bulk_inference.csv`
            
            link.setAttribute('download', filename) //or any other extension
            document.body.appendChild(link)
            link.click()

        },
        increatePredictions(n){
            const current = this.currentUser.creditsTotal
            const toUpdate = {
                userId: this.currentUser.id, 
                update: {
                    creditsTotal: current+n
                }
            }
          
            this.$store.dispatch("updateModelPredictionsTotal", 
                toUpdate
            )
        },
        async invokeBatch(text){
          const refresh = this.result !== null ? false : true
          const payload = {
            userId: this.currentUser.id, 
            modelId: this.project.id, 
            text: text,
            refresh: refresh,
            type: this.project.type,
            url: this.inferenceUrl
          }
          
          const result = await this.$store.dispatch("getModelInferenceBatch", payload);
          this.result = result
          
          return result
        },
        async invoke() {
          this.isLoading = true
          const refresh = this.result !== null ? false : true
          const payload = {
            userId: this.currentUser.id, 
            modelId: this.project.id, 
            text: this.text,
            refresh: refresh,
            type: this.project.type,
            url: this.inferenceUrl
          }
          
          const result = await this.$store.dispatch("getModelInference", payload);
          
          this.increatePredictions(1)
  
          this.result = result
          this.isLoading = false
          this.prediction_results.push({text: this.text, labels: new Array(result["prediction"])})
        },
      cancelUpload(){
            this.inputFile = null
            this.set_text_column = null
            this.set_predictions = null
            this.ready_to_import = null
            this.set_extra_fileformat = null
            this.file_rows = 0
        },
        createRow(){
            this.$store.dispatch('createRow', this.row)
        },
        changeInput() {

            // Only process csv files.
            if (this.inputFile.name.match(/\.(csv)$/)) {
                this.parseFile(this.inputFile);
                this.set_text_column = true
                this.set_extra_fileformat = false
                
            } else {
                return;
            }
            
        },
        setTextColumn(h, k){
            this.text_column_name = h
            this.text_column_key = k
            this.set_text_column = false
            this.ready_to_import = true
            this.uploadFile()
        },
        parseFile(file){
            this.file_rows = 0
            this.isLoadingBatch = true
            Papa.parse( file, {
                header: this.header,
                skipEmptyLines: true,
                complete: function( results ){
                    this.content = results;
                    this.parsed = true;
                    this.file_rows = results.data.length
                    let fields_n = results.data[0].length
                    this.fields_keys = Array.from(Array(fields_n).keys())
                    
                    if (this.header == true){
                        this.fields = results.meta.fields    
                    } else {
                        this.fields = this.fields_keys
                    }
                    
                    this.delimiter = results.meta.delimiter

                }.bind(this)
            });

            this.isLoadingBatch = false

            
        },
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },
        parseComplete(labels){
            console.log(labels)
        },
        uploadFile(){
            this.isLoadingBatch = true
            let that = this
            this.predictions = 0
            this.predictions_results = []
            let total_rows = this.currentUser.creditsLimit | 1000
            this.file_rows = this.file_rows > total_rows ? total_rows : this.file_rows
            Papa.parse(this.inputFile, {
                preview: total_rows,
                complete: function(results) {
                    let col = that.text_column_key 
                    let col_value = that.text_column_name
                    let rows_cleaned = results.data.filter(i => i[col] != undefined && i[col] != " " && i[col] != "" && i[col] != col_value)
                    that.file_rows = rows_cleaned.length
                    let text = rows_cleaned.map(f => f[col])

                    
                    // console.log(text_cleaned)
                    that.invokeBatch(text).then( r => {
                        // console.log(r.results.length)
                        r.results.forEach((v, idx) => {
                            console.log(v, idx)
                            let new_row = [...rows_cleaned[idx], v.prediction.toString(), v.confidence.toString()]
                            that.predictions_results.push(new_row)
                            that.predictions += 1
                        })
                    })
                // },
                // complete: function() {
                    
                    that.set_predictions = true
                    that.ready_to_import = false
                    
                    that.fields.push("prediction")
                    that.fields.push("confidence")


                    that.increatePredictions(that.predictions)

                    
                    
                },
                error: function(err, file, inputElem, reason)
                {
                    // executed if an error occurs while loading the file,
                    // or if before callback aborted for some reason
                    console.log(err, file, inputElem, reason)
                },
            })


            this.finished()

            
        },
        finished(){

            this.isLoadingBatch = false
        }
     },
     mounted() {
        this.$store.dispatch("currentProject", this.projectId)
        this.$store.dispatch("currentUser")
        this.row = {"text": "test", "labels": ["a", "b"]}
        this.currentOrg = []
        this.currentUser = []
     }
   };
</script>

<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>